//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SwappingSquaresSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 65
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  data () {
    return {
      animationBaseName: 'swapping-squares-animation-child',
      squaresNum: 4
    }
  },

  computed: {
    spinnerStyle () {
      return {
        height: `${this.size}px`,
        width: `${this.size}px`
      }
    },

    squareStyle () {
      return {
        height: `${this.size * 0.25 / 1.3}px`,
        width: `${this.size * 0.25 / 1.3}px`,
        animationDuration: `${this.animationDuration}ms`,
        borderWidth: `${this.size * 0.04 / 1.3}px`,
        borderColor: this.color
      }
    },

    squaresStyles () {
      const squaresStyles = []
      const delay = this.animationDuration * 0.5

      for (let i = 1; i <= this.squaresNum; i++) {
        squaresStyles.push(Object.assign({
          animationDelay: `${i % 2 === 0 ? delay : 0}ms`
        }, this.squareStyle))
      }

      return squaresStyles
    }
  }
}
